import { Tooltip, ClickAwayListener } from "dash-styled"

import { useBoolean } from "../../../Hooks/useBoolean"

export interface LabelWithHintProps {
    label: JSX.Element
    hint: JSX.Element
    tooltipPlacement?: "right" | "bottom"
}

export function LabelWithHint({
    label,
    hint,
    tooltipPlacement = "bottom"
}: LabelWithHintProps) {
    const [isDescriptionShown, showDescription, hideDescription] =
        useBoolean(false)

    return (
        <ClickAwayListener onClickAway={hideDescription}>
            <Tooltip
                placement={tooltipPlacement}
                onClose={hideDescription}
                open={isDescriptionShown}
                title={hint}
                classes={{
                    tooltip:
                        "mt-1 p-3 bg-white text-rhino-900 text-sm rounded shadow border border-smoke-890"
                }}
                disableFocusListener={true}
                disableHoverListener={true}
                disableTouchListener={true}
            >
                <button
                    onMouseEnter={showDescription}
                    onMouseLeave={hideDescription}
                    onFocus={showDescription}
                    onBlur={hideDescription}
                >
                    {label}
                </button>
            </Tooltip>
        </ClickAwayListener>
    )
}
